export default __webpack_public_path__ + "static/media/heroAbout.daa557e2.svg";